// src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Register from './pages/Register';
import Login from './pages/Login';
import Products from './pages/Products';
import AddProduct from './pages/AddProduct';
import PendingSellers from './pages/PendingSellers';
import AdminUsers from './pages/AdminUsers';
import AdminProducts from './pages/AdminProducts';
import CartPanel from './components/CartPanel'; 
import './App.css';
import Terms from './pages/Terms';
import ProductDetail from './pages/ProductDetail';
import CheckoutPage from './pages/CheckoutPage';
import ProfilePage from './pages/ProfilePage';
import MyOrders from './pages/MyOrders';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AdminOrders from './pages/AdminOrders'
import SellerOrders from './pages/SellerOrders'
import SellerEditProduct from './pages/SellerEditProduct';
import AboutUs from './pages/AboutUs';



function App() {
  const [cartOpen, setCartOpen] = useState(false);

  return (
    <Router>
      <div className="App">
        {/* Passiamo la funzione setCartOpen alla Navbar in modo che possa aprire/chiudere il carrello */}
        <Navbar setCartOpen={setCartOpen} />
        
        <div className="layout-container">
          <main className="main-content" style={{ minHeight: '80vh' }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/products" element={<Products />} />
              <Route path="/add-product" element={<AddProduct />} />
              <Route path="/pending-sellers" element={<PendingSellers />} />
              <Route path="/admin/users" element={<AdminUsers />} />
              <Route path="/admin/products" element={<AdminProducts />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/my-orders" element={<MyOrders />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/admin/orders" element={<AdminOrders />} />
              <Route path="/seller/orders" element={<SellerOrders />} />
              <Route path="/seller/edit-products" element={<SellerEditProduct />} />
              <Route path="/about" element={<AboutUs />} />
            </Routes>
          </main>
          
          {/* Se cartOpen è true, mostriamo il pannello del carrello accanto al contenuto */}
          {cartOpen && (
            <CartPanel toggleCart={() => setCartOpen(false)} />
          )}
        </div>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
